import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { NoteSelection } from './node-selection';

export class AddOrRemoveSlide {
    /**
     * PC端添加空白模版
     */
    public addPcBlankSlide = () => {
        NoteSelection.clearNoteSelection();
        if (this.getSelectionService()) {
            this.getSelectionService().lastMouseDownRegion = RegionType.SLIDELIST; // 添加幻灯片，把焦点移动到列表
        }
        this.getUiDataService().presentation.addDefaultSlide();
    };

    private getUiDataService() {
        return this.getAppService().getUiDataService();
    }

    private getSelectionService() {
        return this.getAppService()?.viewableServiceLayer?.selectionService;
    }

    private getSectionManager() {
        return this.getAppService()?.viewableServiceLayer?.sectionManager;
    }

    private getAppService() {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}
